import SalvarMixin from './SalvarMixin'
import RecuperarMixin from './RecuperarMixin'
import ListarMixin from './ListarMixin'
import AtivarMixin from './AtivarMixin'
import DeletarMixin from './DeletarMixin'

export const HcSalvarMixin = SalvarMixin
export const HcRecuperarMixin = RecuperarMixin
export const HcListarMixin = ListarMixin
export const HcAtivarMixin = AtivarMixin
export const HcDeletarMixin = DeletarMixin
